import { render, staticRenderFns } from "./ItemListErrors.vue?vue&type=template&id=11a88ef2"
import script from "./ItemListErrors.vue?vue&type=script&lang=js"
export * from "./ItemListErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports